// src/pages/VideoEditorPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import FeedbackTimelineEditor from '../components/FeedbackTimelineEditor'; // ✅ Import your editor

export default function VideoEditorPage() {
  const { videoId } = useParams();
  const [videoURL, setVideoURL] = useState('');

  useEffect(() => {
    const fetchVideo = async () => {
      const videoSnap = await getDoc(doc(db, 'videos', videoId));
      if (videoSnap.exists()) {
        setVideoURL(videoSnap.data().videoURL);
      }
    };
    fetchVideo();
  }, [videoId]);

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">🎬 Feedback Editor</h2>
      {videoURL ? (
        <FeedbackTimelineEditor videoId={videoId} videoURL={videoURL} />
      ) : (
        <p>Loading video...</p>
      )}
    </div>
  );
}
